import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Binoculars, ChartNoAxesCombined, Clock3, Database, UserRoundPlus } from 'lucide-react';
import '../styles/Statshub.css';

const StatsHub = ({ teamId, onViewRecentSubmissions }) => {
  const navigate = useNavigate();

  const panels = [
    {
      icon: <ChartNoAxesCombined size={24} />,
      category: 'MATCH',
      title: 'Team Summary',
      description: 'Record match results, scores, maps, modes, and competition details.',
      cta: 'Record Team Match ->',
      route: `/submit-team-summary?teamId=${teamId}`,
    },
    {
      icon: <UserRoundPlus size={24} />,
      category: 'PLAYERS',
      title: 'Player Stats',
      description: 'Record individual performance, K/D/A, objectives, operators, and impact.',
      cta: 'Record Player Stats ->',
      route: `/addPlayerStatsForm?teamId=${teamId}`,
    },
    {
      icon: <Binoculars size={24} />,
      category: 'SCOUTING',
      title: 'Opponent Scouting',
      description: 'Record match data from other teams to build your scouting database.',
      cta: 'Scout Opponent ->',
      route: '/submit-enemy-stats',
    },
  ];

  const utilityPanels = [
    {
      icon: <Clock3 size={22} />,
      title: 'Recent Submissions',
      description: 'Review, edit, or delete previously submitted match data.',
      cta: 'View submissions ->',
      onClick: onViewRecentSubmissions,
    },
    {
      icon: <Database size={22} />,
      title: 'Database Configuration',
      description: 'Manage teams, competitions, regions, maps, operators, and match options.',
      cta: 'Manage database ->',
      onClick: () => navigate('/settings?tab=database-config'),
    },
  ];

  return (
    <div className="stats-hub-container">
      <div className="stats-hub-inner">
        <header className="stats-hub-header">
          <p className="stats-hub-eyebrow">Data Entry</p>
          <h1 className="hub-title">Stats Hub</h1>
          <p className="hub-subtext">Record, manage, and review your team's match data.</p>
        </header>

        <section className="stats-hub-section">
          <div className="stats-section-heading">
            <p>Record Match Data</p>
            <span>Choose what you want to record.</span>
          </div>

          <div className="stats-panel-grid">
            {panels.map((panel) => (
              <button
                key={panel.title}
                type="button"
                className="stats-panel-card"
                onClick={() => navigate(panel.route)}
              >
                <div className="icon-wrap">{panel.icon}</div>
                <span className="stats-card-category">{panel.category}</span>
                <h3>{panel.title}</h3>
                <p>{panel.description}</p>
                <span className="stats-card-cta">{panel.cta}</span>
              </button>
            ))}
          </div>
        </section>

        <section className="stats-hub-section stats-hub-section-utility">
          <div className="stats-section-heading">
            <p>Manage Data</p>
          </div>

          <div className="stats-utility-grid">
            {utilityPanels.map((panel) => (
              <button
                key={panel.title}
                type="button"
                className="stats-utility-card"
                onClick={panel.onClick}
              >
                <div className="utility-icon-wrap">{panel.icon}</div>
                <div>
                  <h3>{panel.title}</h3>
                  <p>{panel.description}</p>
                </div>
                <span>{panel.cta}</span>
              </button>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default StatsHub;
